import React from 'react'
import { Card, CardBody } from 'reactstrap'
import PropTypes from 'prop-types'
import { TaxRegistrationStore } from '../../../stores/tax-registration'
import { dataSources } from '../../../utils/data-sources'
import { TaxRegistrationForm } from '../../../components/tax-registration-form'
import { inject, observer } from 'mobx-react'
import Http from '../../../services/http'
import { SessionStore } from '../../../stores'
import { PlaceholderCard } from '../../../components/placeholder'
import { getQueryParameters } from '../../../utils/url-query-string-parsing'
import { NoRecords } from '../../../components/no-records/norecords'

@inject('taxRegistrationStore', 'sessionStore')
@observer
class EditTaxRegistrationContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      noRecords: false
    }
    this.http = Http.getInstance(this.props.sessionStore)
    this.dataSources = dataSources()
  }

  componentDidMount () {
    const urlData = getQueryParameters(window.location.href, 1)
    if (urlData.length === 0) {
      this.setState({
        noRecords: true
      })
    } else {
      if (this.props.taxRegistrationStore.currentTaxRegistration) {
        this.setState({
          ready: true
        })
      } else {
        this.loadData(urlData).then((viewData) => {
          if (viewData.status === 'success') {
            const rowData = viewData.data
            this.props.taxRegistrationStore.setCurrentTaxRegistration(rowData)
            this.setState({
              ready: true
            })
          } else {
            const rowData = []
            this.props.taxRegistrationStore.setCurrentTaxRegistration(rowData)
            this.setState({
              ready: true
            })
          }
        })
      }
    }
  }

  loadData (urlData) {
    return this.http.getData(`${this.dataSources.taxRegistrations}/${urlData.taxregistrationid}/?scope=detail`)
  }

  render () {
    if (this.state.ready) {
      return (
        <Card className='rounded-0 border-0 shadow'>
          <CardBody className='p-2 p-lg-4'>
            <TaxRegistrationForm env={this.props.env} />
          </CardBody>
        </Card>
      )
    } else if (this.state.noRecords) {
      return <NoRecords/>
    } else {
      return <PlaceholderCard />
    }
  }
}

EditTaxRegistrationContent.propTypes = {
  taxRegistrationStore: PropTypes.instanceOf(TaxRegistrationStore),
  sessionStore: PropTypes.instanceOf(SessionStore),
  env: PropTypes.object
}

export { EditTaxRegistrationContent }